<template lang="pug">
  app-layout
    v-flex(xs12)
      v-container.py-0.elevation-1.white(fluid)
        v-tabs(slider-color="primary")
          ld-gated-tab(
              v-for="item in items"
              v-if="!isNotAllowToRedirect(item)"
              :key="item.route.name"
              :to="item.route"
              :feature="item.feature"
            ) {{ item.text }}
          div(v-else @click="showUpdateSuscriptionModal")
            ld-gated-tab.pt-2(
              :key="item.route.name"
              :feature="item.feature"
              disabled
            ) {{ item.text }}
          v-spacer.grow
          ld-how-it-works(
            :feature="howToVideoFeature"
          )
      v-container(fluid grid-list-lg)
        v-layout(fill-height row-wrap)
          slot
</template>

<script>
import { envIs } from '@/Core/utilities/envChecks';
import { LdGatedTab, LdFeatures, LdHowItWorks } from 'lion-vue';
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  components: {
    LdGatedTab,
    LdHowItWorks,
  },
  data() {
    return {
      LdFeatures,
      MLS_RESTRICTED_TEXT: 'mlsRetrictedTexts',
    };
  },
  async mounted() {
    this.getIsUserBlocked();
  },
  watch: {
    watcherValue: {
      immediate: true,
      deep: true,
      handler(value) {
        this.handleRedirection();
      }
    },
  },
  computed: {
    ...mapState('userSmsErrorRates', ['isPermaBlocked']),
    ...mapGetters({
      hasMlsUserAccessToTextFeature: 'userInformation/hasMlsUserAccessToTextFeature',
    }),
    ...mapGetters('userInformation', ['hasAccessToFeature', 'userHasFeatureFlag']),
    howToVideoFeature() {
      return this.$route.meta.howToVideoFeature || '';
    },
    userHasTextsAccess() {
      return this.hasAccessToFeature(LdFeatures.TextMessaging);
    },
    items() {
      let items = [
        { route: { name: 'communications.email' }, text: 'Emails' },
        {
          route: { name: 'communications.text' },
          text: 'Texts',
          feature: LdFeatures.TextMessaging,
        },
        {
          route: { name: 'communications.text2sell' },
          text: 'Text2Sell',
          feature: LdFeatures.Text2Sell,
        },
      ];
      if (this.userHasFeatureFlag && !this.userHasTextsAccess) {
        items = [{ route: { name: 'communications.email' }, text: 'Emails' }];
      }
      return items
    },
    watcherValue() {
      return [this.isPermaBlocked, this.userHasTextsAccess, this.$route]
    },
  },
  methods: {
    envIs,
    ...mapActions('subscription', ['toggleFeatureGate']),
    ...mapActions('userSmsErrorRates', ['getIsUserBlocked']),
    isNotAllowToRedirect(tab) {
      return tab.feature === LdFeatures.TextMessaging && this.hasMlsUserAccessToTextFeature;
    },
    showUpdateSuscriptionModal() {
      this.toggleFeatureGate({ feature: this.MLS_RESTRICTED_TEXT });
    },
    handleRedirection(){
      if (!this.isPermaBlocked && !this.userHasTextsAccess && (this.$route.path.includes('text') || this.$route.path.includes('text2sell'))) {
        this.$router.push('/dashboard');
      }
    }
  },
};
</script>
